export default {
    path: 'artist_schedule',
    name: 'artist_schedule',
    component: () => import('@/pages/artist/schedule/Index'),
    meta: { title: '档期管理' },
}
